import { SignalFeedbackContract } from '@terra/shared-contracts-signal-feedback';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const signalFeedbackClient = createTerraOrpcClient({
  contract: SignalFeedbackContract,
  serviceName: SERVICE_NAME,
});
